/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
import {
  makeType,
  parseOptions,
  initLog
} from '../core/base'

import UI from '../core/ui'
import APIChannel from '../core/api_channel'

// import { getWith, maybe, first, guard } from "../ui/core/functions"
// import { guard } from "../core/functions"

import {
  getWith,
  maybe,
  first,
  guard
} from '../core/functions'
import {
  Stream
} from '../core/dispatcher-flyd'
import {
  modelChanged
} from './common'

const proto = {
  name: 'Zoom',
  // injected: null,
  parseOptions,
  initLog,

  init() {
    return {
      url: null,
      show: false
    }
  },

  view(model) {
    guard()
      // disabled for mobile. Change? Add config option?
      .where(window.matchMedia('(min-width: 48em)').matches)
      .do(() => {
        const popup = getWith('target', 'behaviors', 'Popup')(this)
        maybe((popup, url) => {
          const parent = this.dom.closestByRole('slideshow-slide')
          if (parent != undefined && parent.dataset.uri != undefined) {
            if (parent.dataset.uri !== window.location) {
              // console.log(`change window location: ${parent.dataset.uri}`)
              // window.location = parent.dataset.uri
              window.history.replaceState({}, '', parent.dataset.uri)
            }
          }
          // console.log(`zoom url: ${url}`)
          const clearLoader = () => {
            // console.warn(`clearing loader 1`)

            document
              .findByRole('loader')
              .forEach(c => c.dispose())
          }

          if (window.socket == null) {
            // console.warn(`using old url inteface`)
            popup.getURL(url, clearLoader)
          }
          popup.show('zoomed')
        })(popup, model.url)
      })

    model.show = false
    return model
  },

  update(msg, model) {
    // this.log.warn(`update:`, {... msg})
    model = {
      ...model
    }

    if (msg.type === 'click') {
      model.url = this.dom.dataset.uri
      model.show = true

      const ref_name = `zoom${this.dom.dataset.ur}`

      if (window.socket != null) {
        // console.warn(`zoom: using socket`)
        const handler = msg => {
          APIChannel.clear(name)
          // console.warn(`zoom: socket returned: `, msg)
          model.content = msg.content
          const popup = getWith('target', 'behaviors', 'Popup')(this)
          maybe(popup => {
            //  console.warn(`loading socket response`)
            const clearLoader = () => {
              // console.warn(`clearing loader 2`)
              document
                .findByRole('loader')
                .forEach(c => c.dispose())
            }
            popup.loadReponse(msg.content, clearLoader)
            // clearLoader()
          })(popup)
        }
        // const name = this.dom.dataset.action
        const name = 'zoom'
        const ref = APIChannel.send(
          name, {
            value: this.dom.dataset.uri
          },
          handler
        )
        this.handlers[name] = ref
      }
    }

    return model
  },

  initialize(dom) {
    this.dom = dom
    this.handlers = {}
    this.initLog()

    // this.log.warn('initializing:', this.dom)

    this.controls = dom.findByRole('open')
    // this.target = document.findByRole('popup')[0]
    const [ target ] = document.findByRole('popup')
    this.target = target

    let currentModel = this.init()

    this.eventStream = new Stream()
    this.eventStream.map(msg => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      }
      currentModel = model
    })

    this.view(currentModel)

    const glob = this
    this.controls.forEach(t =>
      t.addEvent('click', glob.eventStream.stream))
  }
}

const Zoom = makeType(proto)

UI.register('zoom', Zoom)
